import { c as _c } from "react/compiler-runtime";
import { SUBJECT_VIEW_MODES, VIEW_MODES_CONFIG } from "@components/view-mode-selector/view-mode-selector-constants";
import { ViewModeSelectorItem } from "@components/view-mode-selector/view-mode-selector-item";
import { Box } from "@mui-wrapper";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { dataViewModeSelector } from "@store/ui/ui-selector";
import { setDataViewMode } from "@store/ui/ui-slice";
import { DataViewEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Selector to choose the data view mode for a given subject (groups, projects, etc.)
 */
export function ViewModeSelector(t0) {
  const $ = _c(14);
  const {
    subject
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const subjectsViewMode = useAppSelector(dataViewModeSelector);
  const currentViewMode = subjectsViewMode[subject];
  const viewModes = SUBJECT_VIEW_MODES[subject];
  let t1;
  if ($[0] !== dispatch || $[1] !== subject || $[2] !== trackEvent) {
    t1 = function updateDataViewMode(viewMode) {
      trackEvent({
        name: DataViewEvents.changeViewMode,
        props: {
          viewMode
        }
      });
      dispatch(setDataViewMode({
        subject,
        viewMode
      }));
    };
    $[0] = dispatch;
    $[1] = subject;
    $[2] = trackEvent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateDataViewMode = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundColor: "surfaces.tertiary",
      borderRadius: "4px",
      height: "36px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingX: "3px",
      marginRight: "12px"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentViewMode || $[6] !== updateDataViewMode || $[7] !== viewModes) {
    let t4;
    if ($[9] !== currentViewMode || $[10] !== updateDataViewMode) {
      t4 = viewMode_0 => <ViewModeSelectorItem key={viewMode_0} tooltipTitle={VIEW_MODES_CONFIG[viewMode_0].tooltipTitle} component={VIEW_MODES_CONFIG[viewMode_0].iconComponent} isActive={currentViewMode === viewMode_0} onClick={() => updateDataViewMode(viewMode_0)} />;
      $[9] = currentViewMode;
      $[10] = updateDataViewMode;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = viewModes.map(t4);
    $[5] = currentViewMode;
    $[6] = updateDataViewMode;
    $[7] = viewModes;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <Box component="div" sx={t2}>{t3}</Box>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}